import styled from '@emotion/styled';
import antd from 'antd';

export const Button = styled(antd.Button)`
  color: ${props => props.theme.color.white};
  background: ${props => (props.actionType === 'activate' ? props.theme.color.green : props.theme.color.red)};
  border: none;
`;
